export default "__VITE_ASSET__cfb83d3f__"